module.exports = __webpack_public_path__ + "static/media/can.97fb274d.jpg";